import { gql } from '@apollo/client';

export default gql`
  mutation updatePaymentSource($membershipId: String!, $paymentMethodId: String!) {
    updatePaymentSource(membershipId: $membershipId, paymentMethodId: $paymentMethodId)
  }
`;
